import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import PageHeader from '../components/PageHeader';
import GalleryGrid from '../components/GalleryGrid';

export default function CADDesignFEM() {
  const galleryImages = [
    'https://assets.auxodev.dk/assets/1cab479d-9d2b-49e7-a4f6-be9602b123ca/mekanisk-konstruktion-cad.jpg',
    'https://assets.auxodev.dk/assets/1cab479d-9d2b-49e7-a4f6-be9602b123ca/8a3e6d-38f93c76eb184f888d48b892497ae3dc.jpg',
    'https://assets.auxodev.dk/assets/1cab479d-9d2b-49e7-a4f6-be9602b123ca/2dee4a-f13a7513b1d94a9ca64d009f1172fcf7-mv2.jpg',
  ];

  return (
    <div className="bg-[#0b1017] text-slate-100 min-h-screen">
      <SEO
        title="CAD design og FEM - JARCon ApS"
        description="2D/3D tegning og Finite Elemente Analyse. Tegner i Inventor, men kan også tegne i NX og Creo."
      />

      <PageHeader
        badge="Konsulentydelser"
        title="CAD design og FEM"
        subtitle="2D/3D tegning og Finite Elemente Analyse • Inventor, NX og Creo"
        breadcrumbs={[
          { label: 'Konsulentydelser', path: '/konsulentydelser' },
          { label: 'CAD design og FEM' },
        ]}
        ctaText="Hør mere om CAD bistand"
        ctaLink="/kontakt"
      />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-8 space-y-8">
            <div className="p-8 rounded-xl bg-[#0e1622] border border-slate-800 space-y-4">
              <span className="text-xs font-open-sans text-cyan-400 uppercase tracking-widest font-semibold block">
                CAD &amp; Beregninger
              </span>
              <h2 className="font-display text-2xl font-bold text-white">
                2D/3D tegning og Finite Elemente Analyse
              </h2>
              <p className="text-slate-300 text-base leading-relaxed">
                Tegner i Inventor, men kan også tegne i NX og Creo.
              </p>
              <p className="text-slate-400 text-sm leading-relaxed">
                Præcis 3D CAD-modellering giver overblik over maskinens samlede geometri, bevægelsesmønstre og tolerancer før fremstilling. Ved hjælp af FEM (Finite Element Method) kan spændinger, udbøjninger og kritiske belastninger analyseres, så konstruktionen optimeres i vægt og styrke.
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
              <div className="p-6 rounded-xl bg-[#0e1622] border border-slate-800">
                <h3 className="font-display font-bold text-lg text-white mb-2">Autodesk Inventor</h3>
                <p className="text-xs text-slate-400 leading-relaxed">
                  Komplet 3D mekanisk konstruktion, parter, samlinger, pladeudfoldning og detaljerede 2D arbejdstegninger.
                </p>
              </div>
              <div className="p-6 rounded-xl bg-[#0e1622] border border-slate-800">
                <h3 className="font-display font-bold text-lg text-white mb-2">Siemens NX</h3>
                <p className="text-xs text-slate-400 leading-relaxed">
                  High-end CAD system til avancerede maskinkonstruktioner, komplekse samlinger og industrikrav.
                </p>
              </div>
              <div className="p-6 rounded-xl bg-[#0e1622] border border-slate-800">
                <h3 className="font-display font-bold text-lg text-white mb-2">PTC Creo</h3>
                <p className="text-xs text-slate-400 leading-relaxed">
                  Fleksibel parametrisk konstruktion og tilpasning til kunders eksisterende tegningsgrundlag.
                </p>
              </div>
            </div>

            <GalleryGrid
              title="CAD design og FEM galleri"
              subtitle="Klik for at se detaljerede tekniske billeder"
              images={galleryImages}
            />
          </div>

          <div className="lg:col-span-4 space-y-6">
            <div className="p-6 rounded-xl bg-[#0e1622] border border-slate-800">
              <h3 className="font-display text-base font-bold text-white mb-4">
                Kompetencer i overblik
              </h3>
              <ul className="space-y-3 text-xs font-open-sans text-slate-300">
                <li className="flex items-center gap-2">
                  <i className="fa-solid fa-check text-cyan-400" aria-hidden="true" />
                  <span>2D/3D teknisk tegning</span>
                </li>
                <li className="flex items-center gap-2">
                  <i className="fa-solid fa-check text-cyan-400" aria-hidden="true" />
                  <span>Finite Elemente Analyse (FEM)</span>
                </li>
                <li className="flex items-center gap-2">
                  <i className="fa-solid fa-check text-cyan-400" aria-hidden="true" />
                  <span>Autodesk Inventor</span>
                </li>
                <li className="flex items-center gap-2">
                  <i className="fa-solid fa-check text-cyan-400" aria-hidden="true" />
                  <span>Siemens NX</span>
                </li>
                <li className="flex items-center gap-2">
                  <i className="fa-solid fa-check text-cyan-400" aria-hidden="true" />
                  <span>PTC Creo</span>
                </li>
              </ul>
            </div>

            <div className="p-6 rounded-xl bg-gradient-to-br from-[#0e1622] to-[#070b10] border border-cyan-500/40 text-center space-y-4">
              <span className="text-xs font-open-sans text-cyan-400 uppercase tracking-wider block font-semibold">
                Brug for freelance tegnehjælp?
              </span>
              <p className="text-xs text-slate-300">
                JARCon tilbyder freelance CAD kapacitet på projektbasis tilpasset dit behov.
              </p>
              <Link
                to="/kontakt"
                className="w-full inline-flex items-center justify-center gap-2 px-5 py-3 rounded-md bg-cyan-500 hover:bg-cyan-600 text-white font-bold text-xs uppercase tracking-wider transition-all"
              >
                <span>Kontakt os</span>
                <i className="fa-solid fa-arrow-right" aria-hidden="true" />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
